import { render, staticRenderFns } from "./PasswordLockConfirmation.vue?vue&type=template&id=12589709&scoped=true&"
import script from "./PasswordLockConfirmation.vue.js?vue&type=script&lang=js&"
export * from "./PasswordLockConfirmation.vue.js?vue&type=script&lang=js&"
import style0 from "./PasswordLockConfirmation.vue?vue&type=style&index=0&id=12589709&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12589709",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
